{
  "version": 12,
  "seed": 920260919,
  "sampleWidth": 385,
  "buildHalfWidth": 255,
  "regions": [
    {
      "theme": 2,
      "x": 0,
      "z": 0
    },
    {
      "theme": 1,
      "x": -40,
      "z": -68
    },
    {
      "theme": 5,
      "x": -75,
      "z": 44
    },
    {
      "theme": 3,
      "x": 40,
      "z": 37
    },
    {
      "theme": 9,
      "x": 38,
      "z": -42
    },
    {
      "theme": 6,
      "x": -28,
      "z": -27
    },
    {
      "theme": 7,
      "x": 89,
      "z": 57
    },
    {
      "theme": 8,
      "x": 96,
      "z": -20
    },
    {
      "theme": 10,
      "x": 0,
      "z": 102
    },
    {
      "theme": 11,
      "x": -106,
      "z": -14
    },
    {
      "theme": 12,
      "x": 0,
      "z": 0
    },
    {
      "theme": 50,
      "x": -91,
      "z": -85,
      "disabled": true
    },
    {
      "theme": 51,
      "x": 0,
      "z": -106
    },
    {
      "theme": 52,
      "x": 77,
      "z": -91
    }
  ],
  "lakes": [
    {
      "x": -46,
      "z": 7,
      "radiusX": 18,
      "radiusZ": 14
    },
    {
      "x": 45,
      "z": -12.5,
      "radiusX": 20,
      "radiusZ": 16
    },
    {
      "x": 4,
      "z": 66,
      "radiusX": 22,
      "radiusZ": 16
    },
    {
      "x": 46,
      "z": -70,
      "radiusX": 17,
      "radiusZ": 14
    },
    {
      "x": -112,
      "z": 17,
      "radiusX": 20,
      "radiusZ": 35
    },
    {
      "x": 82,
      "z": 108,
      "radiusX": 28,
      "radiusZ": 18
    }
  ],
  "biomes": {
    "scale": 60,
    "warp": 9,
    "detail": 0,
    "blend": 12
  },
  "channels": [],
  "underwater": {
    "floorHeight": -64,
    "shoreWidth": 2,
    "dropWidth": 2,
    "lakes": [
      {
        "x": -46,
        "z": 7,
        "radiusX": 18,
        "radiusZ": 14
      },
      {
        "x": 45,
        "z": -12.5,
        "radiusX": 20,
        "radiusZ": 16
      },
      {
        "x": 4,
        "z": 66,
        "radiusX": 22,
        "radiusZ": 16
      },
      {
        "x": 46,
        "z": -70,
        "radiusX": 17,
        "radiusZ": 14
      },
      {
        "x": -112,
        "z": 17,
        "radiusX": 20,
        "radiusZ": 35
      },
      {
        "x": 82,
        "z": 108,
        "radiusX": 28,
        "radiusZ": 18
      }
    ]
  }
}
